// routes/DemoRequestRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import DemoRequests from '../components/DemoRequests/DemoRequests';
import AddDemoRequestFormV2 from '../components/DemoRequests/AddDemoRequestV2';

export const demoRequestsRoutes = (
  <Route path="/demo_requests" element={<MainLayout />}>
    <Route index element={<DemoRequests />} />
    <Route path="request_demo" element={<AddDemoRequestFormV2 />} />
  </Route>
);
